import React from 'react';

const LegacyStatsCards = ({ stats, loading, error }) => {
    const defaultStats = [
        {
            label: 'Customers',
            value: '-',
            previousValue: '-',
            trend: '-',
            period: 'Last Month',
            isUp: true
        },
        {
            label: 'Walkin Orders',
            value: '-',
            previousValue: '-',
            trend: '-',
            period: 'Last Month',
            isUp: true
        },
        {
            label: 'LPO Orders',
            value: '-',
            previousValue: '-',
            trend: '-',
            period: 'Last Month',
            isUp: true
        }
    ];

    const displayStats = stats.length > 0 ? stats : defaultStats;

    return (
        <>
            {error && (
                <div className="alert alert-danger" role="alert">
                    <strong>Error:</strong> {error.message}
                </div>
            )}

            <div className="row g-4 mb-4">
                {loading ? (
                    Array.from({ length: 3 }).map((_, index) => (
                        <div key={index} className="col-12 col-md-4">
                            <div className="card">
                                <div className="card-body">
                                    <div className="placeholder-glow">
                                        <span className="placeholder col-6"></span>
                                        <div className="d-flex align-items-center gap-2 mt-2">
                                            <span className="placeholder col-4"></span>
                                            <span className="placeholder col-2"></span>
                                        </div>
                                        <span className="placeholder col-8 mt-2"></span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))
                ) : (
                    displayStats.map((stat, index) => (
                        <div key={index} className="col-12 col-md-4">
                            <div className="card">
                                <div className="card-body">
                                    <h6 className="card-subtitle mb-2 text-muted">{stat.label}</h6>
                                    <div className="d-flex align-items-center gap-2">
                                        <h3 className="card-title mb-0">{stat.value}</h3>
                                        <span className={`badge ${stat.isUp ? 'bg-success' : 'bg-danger'}`}>
                                            {stat.isUp ? '↑' : '↓'} {Math.abs(stat.trend)}%
                                        </span>
                                    </div>
                                    <small className="text-muted">{stat.period}: {stat.previousValue}</small>
                                </div>
                            </div>
                        </div>
                    ))
                )}
            </div>
        </>
    );
};

export default LegacyStatsCards;
